import type { z } from 'zod';

import type { WorkflowListParamsSchema } from '../models/workflow';

const FEATURE_NAME = 'workflow';

export const workflowQueryKeyMap = {
  workflowList: (params?: z.infer<typeof WorkflowListParamsSchema>) =>
    [FEATURE_NAME, 'list', params].filter((item) => item !== undefined),
  workflow: (id: string) => [FEATURE_NAME, id],
  templates: () => [FEATURE_NAME, 'template', 'list'],
  templatesWithPagination: (params?: object) =>
    ['/api/workflows/templates/list-with-pagination', params].filter(
      (item) => item !== undefined,
    ),
  template: (id?: string) => [FEATURE_NAME, 'template', id],
};

export const workflowInvalidateQueryKeyMap = {
  updateTemplateList: (id?: string) => [
    workflowQueryKeyMap.templates(),
    workflowQueryKeyMap.templatesWithPagination(),
    workflowQueryKeyMap.template(id),
  ],
};
